<template>
  <div class="report-dialog">
    <el-dialog :visible.sync="visibleDialog">
      <div slot="title">
        {{ $t('Create New Report') }}
      </div>
      <el-form ref="reportDialogForm"
               v-loading="isLoading"
               :status-icon="true"
               :model="ReportModel"
               :rules="formRules"
               label-width="105px"
               label-position="left"
               @submit.native.prevent="submitForm('reportDialogForm')">
        <el-form-item :label="$t('Report Type')"
                      prop="type">
          <el-select v-model="ReportModel.type">
            <el-option label="Visit" value="visit" />
            <el-option label="Stock Availability" value="stock_availability" />
            <el-option label="Facing Report" value="facing" />
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('Start Date')"
                      :editable="false"
                      prop="start_date">
          <el-date-picker v-model="ReportModel.start_date"
                          value-format="yyyy-MM-dd" />
        </el-form-item>

        <el-form-item :label="$t('End Date')"
                      prop="end_date">
          <el-date-picker v-model="ReportModel.end_date"
                          :editable="false"
                          value-format="yyyy-MM-dd" />
        </el-form-item>
        <el-button type="primary"
                   native-type="submit">
          {{ $t('Create') }}
        </el-button>
      </el-form>
    </el-dialog>
    <el-button slot="reference"
               :loading="isLoading"
               type="primary"
               class="create-new-report-btn"
               @click="showDialog">
      {{ $t('Create New Report') }}
    </el-button>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import errorResolver from '@/helpers/errorResolver';
import { createReport } from '../api';

export default {
  name: 'ReportDialog',
  props: {
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      ReportModel: {
        type: '',
        start_date: '',
        end_date: ''
      },
      formRules: {
        type: [
          {
            required: true, message: this.$t('Field is required'), trigger: 'blur'

          }
        ],
        start_date: [
          {
            required: true, message: this.$t('Field is required'), trigger: 'blur'
          }
        ],
        end_date: [
          {
            required: true, message: this.$t('Field is required'), trigger: 'blur'

          }
        ]
      },
      visibleDialog: false,
      isLoading: false
    };
  },
  methods: {
    showDialog() {
      this.visibleDialog = true;
    },
    submitForm(formName) {
      const { projectId, ReportModel } = this;

      this.$refs[formName].validate((valid) => {
        if (valid) {
          try {
            this.isLoading = true;
            createReport(projectId, ReportModel)
              .then(() => {
                Message({ type: 'success', message: this.$t('Report will be created.') });
                this.visibleDialog = false;
              });
            this.isLoading = false;
          } catch (error) {
            const { message } = errorResolver(error);
            Message({
              type: 'error',
              title: 'Error',
              message
            });
          }
        }
      });
    }
  }
};
</script>
<style lang='scss'>
.report-dialog {
  display: flex;
  flex-direction: row-reverse;

  .create-new-report-btn {
    text-transform: uppercase;

    @include breakpoint(lg-max) {
      height: 35px;
      padding: 8px 25px;
      margin-bottom: 18px;
    }
  }

  .el-dialog {
    max-width: 382px;

    @include breakpoint(md-max) {
      width: 80%;
    }
  }

  .el-date-editor {
    width: 100%;
    max-width: 193px;
  }
}
</style>
